const Footer = () => {
  return (
    <footer className="bg-dark text-white py-4">
      <div className="container text-center">
        <p className="mb-0">&copy; 2023 SoftSell. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer